import useAuth from "@hooks/useAuth"
import { useEffect, useMemo } from "react"

export default function useHooks(
    salon: Model.Response<Jury.Resources.Salon>, 
    api: Jury.Models.Salon.Api, 
    methods: Jury.Models.Salon.Methods,
    actions: Jury.Models.Salon.Actions
): Jury.Models.Salon.Hooks {
    return {

    }
}